import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import api from '../services/api';

export const useAuthStore = defineStore('auth', () => {
  // State
  const user = ref(null);
  const token = ref(localStorage.getItem('token'));

  // Getters
  const isAuthenticated = computed(() => !!token.value);
  const currentUser = computed(() => user.value);

  // Actions
  const setToken = (newToken) => {
    token.value = newToken;
    if (newToken) {
      localStorage.setItem('token', newToken);
    } else {
      localStorage.removeItem('token');
    }
  };

  const setUser = (userData) => {
    user.value = userData;
  };

  const login = async (credentials) => {
    const response = await api.post('/login', credentials);
    const { token: authToken, user: userData } = response.data;

    setToken(authToken);
    setUser(userData);

    return response;
  };

  const register = async (userData) => {
    const response = await api.post('/register', userData);
    const { token: authToken, user: newUser } = response.data;

    setToken(authToken);
    setUser(newUser);

    return response;
  };

  const logout = async () => {
    try {
      await api.post('/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setToken(null);
      setUser(null);
    }
  };

  const fetchUser = async () => {
    try {
      const response = await api.get('/me');
      setUser(response.data.user);
      return response;
    } catch (error) {
      setToken(null);
      setUser(null);
      throw error;
    }
  };

  const updateProfile = async (profileData) => {
    const response = await api.put('/profile', profileData);
    setUser(response.data.user);
    return response;
  };

  const forgotPassword = async (email) => {
    return api.post('/forgot-password', { email });
  };

  const resetPassword = async (data) => {
    return api.post('/reset-password', data);
  };

  return {
    // State
    user,
    token,
    // Getters
    isAuthenticated,
    currentUser,
    // Actions
    login,
    register,
    logout,
    fetchUser,
    updateProfile,
    forgotPassword,
    resetPassword,
  };
});
